import { SaveOutlined } from '@ant-design/icons';
import { Button, Card, Col, Form, message, Radio, Row, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import Firma from '../../components/Firma';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';

function CatastroFirma() {
  const [form] = Form.useForm();

  const [loadingInicial, setLoadingInicial] = useState(false);
  const [loadingGuardar, setLoadingGuardar] = useState(false);

  const fetch = async () => {
    setLoadingInicial(true);
    try {
      const response = await instanceRef.instance.get(`/usuarios/firma`);
      const firmaUsuario = response.data.data;
      form.setFieldsValue(firmaUsuario);
      setLoadingInicial(false);
    } catch (err) {
      setLoadingInicial(false);
      errorHandler(err);
    }
  };

  const onFinish = async (values) => {
    setLoadingGuardar(true);
    try {
      const data = values;
      await instanceRef.instance.post(`usuarios/firma`, data);
      message.success('Firma actualizada correctamente');
      setLoadingGuardar(false);
      return null;
    } catch (error) {
      setLoadingGuardar(false);
      return error;
    }
  };

  const onFinishFailed = () => {
    message.warning('Completá todos los campos requeridos.');
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ResponsiveContainer size="large">
      <Card title="Información de Firma" style={{ textAlign: 'left' }}>
        <Spin spinning={loadingInicial}>
          <>
            <Form
              name="catastro-firma"
              onFinish={onFinish}
              onFinishFailed={() => onFinishFailed()}
              scrollToFirstError
              form={form}
              layout="vertical"
              autoComplete="off"
            >
              <Row
                gutter={[16, 0]}
                style={{ maxWidth: '1200px', margin: 'auto' }}
              >
                <Col xs={24} md={24} align="start">
                  <Form.Item
                    label="Tipo de firma"
                    name="tipo"
                    rules={[{ required: true, message: 'Requerido' }]}
                  >
                    <Radio.Group>
                      <Radio value="ninguna">Ninguna</Radio>
                      {/* <Radio value="digital">Firma Digital</Radio> */}
                      <Radio value="electronica">Firma Electrónica</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Form.Item noStyle dependencies={['tipo']}>
                  {({ getFieldValue }) =>
                    ['digital', 'electronica'].includes(
                      getFieldValue('tipo')
                    ) && (
                      <Col xs={24} md={24} align="start">
                        <Form.Item
                          label="Catastro de firma"
                          name="firma"
                          normalize={(value) => value.split(',')[1]}
                          rules={[{ required: true, message: 'Requerido' }]}
                        >
                          <Firma text="Catastrar" preview />
                        </Form.Item>
                      </Col>
                    )
                  }
                </Form.Item>
                {/* <Col xs={24} md={12} align="start">
                  <Form.Item label="Usuario" name="user">
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} align="start">
                  <Form.Item label="Contraseña" name="pass">
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} align="start">
                  <Form.Item label="Certificado" name="id_certificado">
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} align="start">
                  <Form.Item label="Catastro de firma" name="firma">
                    <Input />
                  </Form.Item>
                </Col> */}
              </Row>
              <Row justify="center">
                <div>
                  <Button
                    htmlType="submit"
                    loading={loadingGuardar}
                    icon={<SaveOutlined />}
                    type="primary"
                    style={{ margin: 20 }}
                  >
                    Guardar
                  </Button>
                </div>
              </Row>
            </Form>
          </>
        </Spin>
      </Card>
    </ResponsiveContainer>
  );
}

export default CatastroFirma;
